import { render } from "./ChatGroupCard.vue?vue&type=template&id=2d862354&scoped=true&ts=true&lang=pug"
import script from "./ChatGroupCard.vue?vue&type=script&lang=ts"
export * from "./ChatGroupCard.vue?vue&type=script&lang=ts"

import "./ChatGroupCard.vue?vue&type=style&index=0&id=2d862354&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d862354"]])

export default __exports__